import { get, post, put, del, remove, patch } from '@/utils/request';

// 用户登录
export function login(loginData) {
  return post('/Users/Login', loginData); 
}
// 登录日志
export function LoginLogs(Data) {
  return post('/LoginLogs/List', Data); 
}
// 保存用户
export function UsersAdd(Data) {
  return post('/Users/Add', Data); 
}
// 用户列表
export function UsersList(Data) {
  return post('/Users/List', Data); 
}
// 用户删除
export function UsersDel(Data) {
  return post('/Users/del', Data); 
}
